import React from 'react';
import { connect } from 'react-redux';

import { withModal } from 'components/modal/ModalHOC';
import Page from 'components/page/Page';
import PageHeading from 'components/page/page-heading/PageHeading';
import SidebarPage from 'components/page/sidebar-page/SidebarPage';
import SettingsSidebar from 'modules/settings/SettingsSidebar';

import BrandCcmOnboadModal from '../components/brand-ccm-onboard-modal/BrandCcmOnboardModal';
import BrandCreateProfile from '../components/BrandCreateProfile';

import { t } from 'utils/language';
import { navigate } from 'libs/router';
import { getItem, setItem } from 'utils/storage/localStorage';
import { isOrgNewCcmBrand } from '../utils/ccm-brand';

import type { Organization } from 'types';

type StateProps = {
  currentOrganization: Organization,
  isNewCcmBrand: boolean
};

type OwnProps = {};
type Props = StateProps & OwnProps;

const STORAGE_KEY = 'BrandCcmOnboadModal';

class BrandCreateProfilePage extends React.Component<Props> {
  handleAfterSave = async () => {
    const { currentOrganization } = this.props;
    navigate.to(`/organizations/${currentOrganization.id}/brand/settings`);
  };

  render() {
    const {
      currentOrganization,
      isNewCcmBrand
    } = this.props;
    const CcmModal = withModal(<div />, {
      modalContent: BrandCcmOnboadModal,
      autoOpenModal: isNewCcmBrand,
      onModalClosed: () => setItem(`${STORAGE_KEY}-${currentOrganization?.id ?? -1}`, '1')
    });

    if (!currentOrganization) {
      return null;
    }

    return (
      <Page
        documentTitle={t('create_profile_page')}
      >
        <SidebarPage
          scrollable
          sidebarWidth="narrow"
          sidebarContent={<SettingsSidebar />}
        >
          <PageHeading
            heading={t('create_profile_page')}
          />
          <BrandCreateProfile
            organizationType={currentOrganization.type}
            organizationId={currentOrganization.id}
            onAfterSave={this.handleAfterSave}
          />
        </SidebarPage>
        <CcmModal />
      </Page>
    );
  }
}

function mapStateToProps({ organizations, runtimeConfig }): StateProps {
  return {
    currentOrganization: organizations.currentOrganization,
    isNewCcmBrand: (runtimeConfig.config.isCcmEnabled ?? false) && isOrgNewCcmBrand(
      organizations?.currentOrganization ?? null,
      () => (
        getItem(`${STORAGE_KEY}-${organizations?.currentOrganization?.id ?? -1}`) === '1'
      )
    )
  };
}

export default connect(mapStateToProps)(BrandCreateProfilePage);
